import { html, nothing } from "lit-html";
import { ifDefined } from "lit-html/directives/if-defined.js";
import I18nService from "Services/I18nService";

import { DVAGCYoutubeVideo } from "./dvagc-m-youtube-video";
export interface VideoPlayerTemplateParameter<T = DVAGCYoutubeVideo> {
  component: T;
}

const getPosterImage = (component: DVAGCYoutubeVideo) => {
  const poster =
    component.posterSrc !== undefined ? component.posterSrc : `https://img.youtube.com/vi/${component.videoID}/0.jpg`;

  return html`
    <button class="dvagc-m-youtube-video__play-cta">
      <dvag-e-lazy-image
        class="dvag-e-lazy-image"
        src="${poster}"
        srcset="${ifDefined(component.posterSrcSet)}"
        sizes="${ifDefined(component.posterSizes)}"
        loading-placeholder=${ifDefined(component.posterLoadingPlaceholder)}
        alt="${ifDefined(component.posterAlt)}"
        aspect-ratio="16:9"
      >
      </dvag-e-lazy-image>
      <div class="dvagc-m-youtube-video__play-icon-box">
        <dvag-e-icon class="dvagc-m-youtube-video__play-icon" icon-id="dvagc-icon-play"></dvag-e-icon>
      </div>
      <div class="dvagc-m-youtube-video__loading-spinner">
        <div class="dvagc-m-youtube-video__loading-bounce"></div>
        <div class="dvagc-m-youtube-video__loading-bounce"></div>
      </div>
    </button>
  `;
};

const renderConsentOverlay = async (args: VideoPlayerTemplateParameter) => {
  if (args.component.hasConsent === true) return nothing;
  return html`
    <div class="dvagc-m-consent-blocking-overlay">
      <p class="dvagc-m-consent-blocking-overlay__text">
        ${(await I18nService.getValue("dvag.dvag-career.youTube.consentText")) || ""}
      </p>

      <button
        class="dvag-e-button dvag-e-button--small dvagc-m-consent-blocking-overlay__btn"
        @click=${() => args.component.acceptConsent()}
      >
        <div class="dvag-e-button__background"></div>
        <span class="dvag-e-button__label">
          ${(await I18nService.getValue("dvag.dvag-career.youTube.buttonLabel")) || ""}
        </span>
      </button>
    </div>
  `;
};

export const videoPlayerTemplate = async (args: VideoPlayerTemplateParameter) => {
  return html`
    <div class="dvagc-m-youtube-video__video" id="${args.component.playerContainerID}"></div>
    ${getPosterImage(args.component)} ${await renderConsentOverlay(args)}
  `;
};
